import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyInvoiceStatusBar, { BuyInvoiceStatusBarNew, CreateInvoiceStatusBarProps } from '../../../BuyInvoiceStatusBar'
import BuyInvoiceCreateNoPermissionButtons, { BuyInvoiceCreateNoPermissionButtonsNew } from '../BuyInvoiceCreateNoPermissionButtons'

type BuyInvoiceCreateNoPermissionStepHeaderProps = & CreateInvoiceStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyInvoiceCreateNoPermissionStepHeaderDecider: React.FC<BuyInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyInvoiceCreateNoPermissionStepHeaderDefault} NewComponent={BuyInvoiceCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const BuyInvoiceCreateNoPermissionStepHeaderDefault: React.FC<BuyInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyInvoiceStatusBar {...rest} />
            <BuyInvoiceCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const BuyInvoiceCreateNoPermissionStepHeaderNew: React.FC<BuyInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyInvoiceStatusBarNew {...rest} />
            <BuyInvoiceCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyInvoiceCreateNoPermissionStepHeaderDecider